export var AuthenticateStatus;
(function (AuthenticateStatus) {
    AuthenticateStatus["Valid"] = "valid";
    AuthenticateStatus["AccountNotFound"] = "accountNotFound";
    AuthenticateStatus["AccountDisabled"] = "accountDisabled";
    AuthenticateStatus["AccountLocked"] = "accountLocked";
    AuthenticateStatus["PasswordExpired"] = "passwordExpired";
    AuthenticateStatus["ServerError"] = "serverError";
    AuthenticateStatus["UserFound"] = "userFound";
    AuthenticateStatus["NotAuthenticated"] = "notAuthenticated";
    AuthenticateStatus["SessionExpired"] = "sessionExpired";
    AuthenticateStatus["SessionValid"] = "sessionValid";
})(AuthenticateStatus || (AuthenticateStatus = {}));
//# sourceMappingURL=AuthenticateStatus.js.map